import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PRODUCT } from 'app/pages/products/product';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppConfigService } from '../app-config/app-config.service';
import { AbstractHttpService } from '../base/abstract.http.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends AbstractHttpService<any> {

  constructor(protected _httpClient: HttpClient,
    private appConfigService: AppConfigService) {
    super(_httpClient, PRODUCT, appConfigService.apiBaseUrl);
  }

  getFeaturedProducts(page: number, order: number): Observable<any> {
    return this.customList(`featuredCategory/page/${page}/order/${order}${this.buildQueryParams()}`).pipe(take(1));
  }

  getProductsByCategory(categoryId: number, page: number, order: number): Observable<any> {
      return this.customList(`category/${categoryId}/page/${page}/order/${order}${this.buildQueryParams()}`).pipe(take(1));
  }

  getOffers(page: number, order: number): Observable<any>{
    return this.customList(`offers/page/${page}/order/${order}${this.buildQueryParams()}`).pipe(take(1));
  }

  // find(filter: string): Observable<any> {
  //   return this.customList(`${filter}${this.buildQueryParams()}`).pipe(take(1));
  // }

  find(page: number, filter: string, sortOrder: number): Observable<any> {
    return this.customList(`search/page/${page}?name=${filter}&order=${sortOrder}`).pipe(take(1));
  }

  getAll(page: number, order: number) {
    // Busca por todos os produtos é a mesma, enviando categoria como "-1"
    return this.getProductsByCategory(-1, page, order).pipe(take(1));
  }

  getSimpleByIdAndClas(productId: number, clasId: number) {
    return this.customList(`simpleProduct/${productId}/idClas/${clasId}${this.buildQueryParams()}`).pipe(take(1));
  }

  getProductByIdAndClas(productId: number, clasId: number) {
    return this.customRead(`${productId}/idClas/${clasId}${this.buildQueryParams()}`).pipe(take(1));
  }

  buildQueryParams(): string {
    var params = '';

    try {
      var receivingCondition = JSON.parse(sessionStorage.getItem('selectedReceivingCondition'));
    } catch (error) { 
    }

    if (receivingCondition != null) {
      receivingCondition = receivingCondition.id;
    } else {
      receivingCondition = sessionStorage.getItem('selectedReceivingConditionId');
    }

    if (receivingCondition != null) {
      params += `paymentCondition=${receivingCondition}`
    }
    var paymentForm = null;
    try {
      JSON.parse(sessionStorage.getItem('selectedPaymentReceiptForm'));
    } catch (error) {
    }
    if (paymentForm != null) {
      paymentForm = paymentForm.id;
    } else {
      paymentForm = sessionStorage.getItem('selectedPaymentReceiptFormId');
    }

    if (paymentForm != null) {
      params += `${(params != '' ? '&' : '')}paymentForm=${paymentForm}`
    }

    return (params != null ? `?${params}` : '');
  }
}
